import React from "react";

export const RightArrowIcon = () => {
    return (
        <svg width="10" height="10" viewBox="0 0 10  10 " fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Rectangle 4465"
                  d="M1.66436 9.5C1.01946 9.5 0.677294 8.73804 1.10574 8.25604L4 5L1.10574 1.74396C0.677294 1.26196 1.01946 0.5 1.66436 0.5C1.87785 0.5 2.08115 0.591294 2.22298 0.750857L6 5L2.22298 9.24914C2.08115 9.40871 1.87785 9.5 1.66436 9.5Z"
                  fill="#6EC191"/>
        </svg>
    );
}